export default __webpack_public_path__ + "static/media/copy-icon.066acd31.svg";